export const SITE = {
  name: 'Cambridge Carpenter',
  url: 'https://www.cambridgecarpenter.co.uk',
  phone: '07798 525115',
  phoneHref: 'tel:07798525115',
  email: 'hello@cambridgecarpenter.co.uk',
  address: {
    street: '2 Cuckoo Lane',
    town: 'Cambridge',
    postcode: 'CB24 8QH',
  },
  areas: [
    'Cambridge',
    'Cherry Hinton',
    'Trumpington',
    'Girton',
    'Histon',
    'Milton',
    'Fulbourn',
    'Great Shelford',
    'Sawston',
    'Waterbeach',
    'Cambourne',
    'Ely',
    'Newmarket',
    'Saffron Walden',
  ],
};

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'HomeAndConstructionBusiness',
  '@id': `${SITE.url}/#business`,
  name: SITE.name,
  description:
    'Carpentry and joinery company in Cambridge building fitted furniture, kitchens, decking, loft conversions and bespoke timberwork across Cambridgeshire.',
  url: SITE.url,
  telephone: '+447798525115',
  email: SITE.email,
  image: `${SITE.url}/cambridge-carpenter.png`,
  logo: `${SITE.url}/cambridge-carpenter.png`,
  priceRange: '££',
  address: {
    '@type': 'PostalAddress',
    streetAddress: SITE.address.street,
    addressLocality: SITE.address.town,
    postalCode: SITE.address.postcode,
    addressCountry: 'GB',
  },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Cambridgeshire' },
    ...SITE.areas.map((name) => ({ '@type': 'City', name })),
  ],
};
